import { IntlContext } from './IntlContext';

// export * from './createIntl';
export { createIntl } from './createIntl';

export const IntlProvider = IntlContext.Provider;
export const IntlConsumer = IntlContext.Consumer;
export const useIntl = IntlContext.useContext;
